export const technicianSelectConfig = {
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 150,
            sorter: true,
        },
        {
            title: "Имя",
            dataIndex: "firstName",
            key: "firstName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Фамилия",
            dataIndex: "lastName",
            key: "lastName",
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Отчество",
            dataIndex: "middleName",
            key: "middleName",
            sorter: true,
            ellipsis: true,
            render: (middleName) => middleName || "—",
        },
        {
            title: "Телефон",
            dataIndex: "phone",
            key: "phone",
            sorter: true,
            width: 150,
            render: (phone) => phone || "—",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sorter: true,
            ellipsis: true,
            render: (email) => email || "—",
        },
    ],
    rowKey: "id",
    pagination: {
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} техников`,
    },
};
